module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0098.jpg?v=1dbe7223";